import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/equip-title.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-55628166"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "main"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "main-top"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "eq-pic"
  }), /*#__PURE__*/_createElementVNode("div", {
    class: "mian-font"
  }, "产品信息")], -1);
});

var _hoisted_3 = {
  class: "route"
};

var _hoisted_4 = /*#__PURE__*/_createTextVNode("产品规格");

var _hoisted_5 = /*#__PURE__*/_createTextVNode("购买渠道");

var _hoisted_6 = /*#__PURE__*/_createTextVNode("配套软件");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = _resolveComponent("router-link");

  var _component_router_view = _resolveComponent("router-view");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [_createVNode(_component_router_link, {
    to: "/product/detail",
    "active-class": "active"
  }, {
    default: _withCtx(function () {
      return [_hoisted_4];
    }),
    _: 1
  })]), _createElementVNode("div", null, [_createVNode(_component_router_link, {
    to: "/product/buy",
    "active-class": "active"
  }, {
    default: _withCtx(function () {
      return [_hoisted_5];
    }),
    _: 1
  })]), _createElementVNode("div", null, [_createVNode(_component_router_link, {
    to: "/product/info",
    "active-class": "active"
  }, {
    default: _withCtx(function () {
      return [_hoisted_6];
    }),
    _: 1
  })])]), _createVNode(_component_router_view)]);
}